<template>
  <div class="basic-layout">
    <spin :spinning="globalLoading" />
    <section class="header">
      <section class="page-content">
        <section class="logo">
          <template v-if="commonInfo.companyLogo">
            <section v-html="commonInfo.companyLogo"></section>
          </template>
        </section>
        <section class="nav">
          <router-link
            to="/"
            :class="{ active: currentPath === '/' || currentPath === '/home' }"
          >首页</router-link>
          <router-link
            to="/information_exposure"
            :class="{ active: currentPath.startsWith('/information_exposure') }"
          >信息披露</router-link>
        </section>
      </section>
    </section>
    <section class="content">
      <router-view></router-view>
    </section>
    <section class="footer">
      <section class="modules-container page-content">
        <section
          class="module"
          :class="{ [footerModule.key]: true }"
          v-for="footerModule in footerModules"
          :key="footerModule.key"
        >
          <p class="title">{{ footerModule.title }}</p>
          <ul>
            <li
              v-for="item in footerModule.items"
              :key="item.key"
            >
              <template v-if="item.type === 'show'">
                {{ item.label }}：{{ commonInfo[item.key] }}
              </template>
              <template v-if="item.type === 'modal'">
                <span
                  class="clickable"
                  @click="modalHandler(item)"
                >{{
                  item.label
                }}</span>
              </template>
              <template v-if="item.type === 'link'">
                <a
                  target="_blank"
                  :href="commonInfo[item.key]"
                  class="clickable"
                >{{ item.label }}</a>
              </template>
            </li>
          </ul>
        </section>
        <section class="module qrcode">
          <p class="title">扫码关注微信公众号</p>
          <section class="qrcode-containers">
            <section class="qrcode">
              <span class="title">金保信</span>
              <p v-html="commonInfo.jbxQrCode"></p>
            </section>
            <section class="qrcode">
              <span class="title">保障联盟</span>
              <p v-html="commonInfo.bzlmQrCode"></p>
            </section>
          </section>
        </section>
      </section>
      <p class="copyright">
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
        >粤ICP备17127322号</a>

        <!-- <a
          href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=待补充"
          target="_blank"
          >待备案</a
        > -->

        {{ this.commonInfo.copyrightNotice }}
        <img
          :src="require('@/assets/filing_icon.png')"
          alt=""
        >
        <a
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502010275"
          target="_blank"
        >粤公网安备 44030502010275号</a>
      </p>
    </section>
    <section
      class="to-top"
      :class="{ show: toStopShow }"
      @click="scrollToTop"
    >
      <img
        src="https://static.soyoung.com/sy-pre/3tn4ogravhz4c-1682665800711.png"
        alt=""
      />
      <span>返回<br />顶部</span>
    </section>
    <Modal
      v-bind="modalProps"
      v-model="modalProps.visible"
      @change="updateModalVisible"
    >
      <section v-html="modalContent"></section>
    </Modal>
  </div>
</template>

<script>
import Modal, { modalMixin } from "@/components/modal";
import Spin from "@/components/Spin.vue";
import GlobalStore from "@/store/global";
import { get } from "lodash";
import { getViewPortHeight } from "@/utils";
export default {
  name: "basic-layout",
  components: { Modal, Spin },
  mixins: [modalMixin],
  data() {
    return {
      // commonInfo: {},
      footerModules: [
        {
          title: "客户服务",
          key: "clientService",
          items: [
            {
              label: "保险指南",
              key: "insuranceGuide",
              type: "modal",
            },
            {
              label: "保障措施",
              key: "securityMeasures",
              type: "modal",
            },
            {
              label: "保单说明",
              key: "policyDescription",
              type: "modal",
            },
            {
              label: "保单验真",
              key: "policyAuthentication",
              type: "modal",
            },
          ],
        },
        {
          title: "协议政策",
          key: "protocols",
          items: [
            {
              label: "服务协议",
              key: "serviceAgreement",
              type: "modal",
            },
            {
              label: "隐私政策",
              key: "privacyPolicy",
              type: "modal",
            },
            {
              label: "保险资质查询",
              key: "insuranceQualificationInquiry",
              type: "link",
            },
            {
              label: "保险行业协会",
              key: "insuranceIndustryAssociation",
              type: "link",
            },
          ],
        },
        {
          title: "联系我们",
          key: "contactUs",
          items: [
            {
              label: "官方邮箱",
              key: "officialEmail",
              type: "show",
            },
            {
              label: "客服电话",
              key: "customerServicePhone",
              type: "show",
            },
            {
              label: "投诉电话",
              key: "complaintPhone",
              type: "show",
            },
            {
              label: "公司地址",
              key: "companyAddress",
              type: "show",
            },
          ],
        },
      ],
      modalContent: "",
      toStopShow: false,
    };
  },
  computed: {
    currentPath() {
      return this.$route.path;
    },
    commonInfo() {
      return GlobalStore.commonInfo;
    },
    globalLoading() {
      return GlobalStore.loading;
    },
  },
  created() {
    this.getCommonInfo();
  },
  mounted() {
    window.addEventListener("scroll", this.scrollHandler);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollHandler);
  },
  methods: {
    getCommonInfo() {
      this.$get("/base/official-site/anonymous/common-info")
        .then((res) => {
          const data = get(res, "data");
          if (data) {
            GlobalStore.commonInfo = data;
          }
        })
        .catch((error) => { });
    },
    onModalVisibleChange(visible) {
      this.modalVisible = visible;
    },
    /** 弹窗类型 */
    modalHandler(item) {
      const modalContent = this.commonInfo[item.key];
      this.modalContent = modalContent ? modalContent : "";
      this.updateModalProps({
        title: item.label,
        visible: true,
      });
    },
    scrollHandler() {
      try {
        const el = document.documentElement || document.body;
        const scrollTop = el.scrollTop;
        const viewportHeight = getViewPortHeight();
        if (scrollTop < viewportHeight && this.toStopShow) {
          this.toStopShow = false;
        }
        if (scrollTop > viewportHeight && !this.toStopShow) {
          this.toStopShow = true;
        }
      } catch (error) { }
    },
    scrollToTop() {
      try {
        const el = document.documentElement || document.body;
        el.scroll({
          top: 0,
        });
      } catch (error) { }
    },
  },
};
</script>

<style lang="less">
.basic-layout {
  padding-top: 60px;
  .header {
    position: fixed;
    z-index: 4;
    top: 0;
    left: 0;
    right: 0;
    padding: 18px 0;
    background: #ffffff;
    box-shadow: 0 10px 10px 0 rgba(135, 164, 208, 0.06);
    .page-content {
      display: flex;
      align-items: center;
      .logo {
        width: 72px;
        height: 24px;
        p {
          width: 100%;
          height: 100%;
          img {
            display: block;
          }
          br {
            display: none;
          }
        }
      }
      .nav {
        padding-left: 60px;
        display: flex;
        align-items: center;
        a {
          text-decoration: none;
          font-size: 14px;
          color: #53595f;
          line-height: 20px;
          display: block;
          position: relative;
          &.active {
            color: #121519;
            font-weight: bold;
            &::after {
              content: "";
              display: block;
              width: 100%;
              height: 2px;
              background: #0044c1;
              position: absolute;
              left: 50%;
              right: -4px;
              transform: translateX(-50%);
            }
          }
        }
        a + a {
          margin-left: 24px;
        }
      }
    }
  }
  .footer {
    position: relative;
    padding: 32px 0;
    background: #303746;
    .modules-container {
      display: flex;
      justify-content: space-between;
      .module {
        .title {
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0;
          font-weight: bold;
          line-height: 20px;
          padding-bottom: 20px;
        }
        ul {
          li {
            list-style: none;
          }
          li,
          li span,
          li a {
            text-decoration: none;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #ffffff;
            letter-spacing: 0;
            line-height: 17px;
          }
          li + li {
            margin-top: 14px;
          }
        }
        &.qrcode {
          .qrcode-containers {
            display: flex;
            align-items: center;
            .qrcode {
              .title {
                display: block;
                font-size: 12px;
                color: #ffffff;
                letter-spacing: 0;
                line-height: 17px;
                padding-bottom: 5px;
              }
              p {
                width: 88px;
                height: 88px;
                br {
                  display: none;
                }
              }
            }
            .qrcode + .qrcode {
              margin-left: 62px;
            }
          }
        }
      }
    }
    .copyright,
    .copyright a {
      text-decoration: none;
      text-align: center;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      line-height: 17px;
      color: rgba(255, 255, 255, 0.6);
      letter-spacing: 0;
      padding-top: 50px;
    }
    .copyright img {
      display: inline-block;
      margin-right: 3px;
      vertical-align: bottom;
    }
  }
  .to-top {
    position: fixed;
    right: 42px;
    top: 80%;
    display: none;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background-image: linear-gradient(-85deg, #f2f6fc 8%, #eff5ff 98%);
    box-shadow: -4px -4px 10px 0 rgba(255, 255, 255, 0.73),
      4px 4px 10px 0 rgba(206, 220, 243, 0.55);
    cursor: pointer;
    &.show {
      display: flex;
    }
    & > img {
      width: 16px;
      height: 16px;
    }
    & > span {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      line-height: 17px;
      color: #53595f;
      padding-top: 2px;
    }
  }
}
@media all and (max-width: 1200px) {
  .basic-layout {
    padding-top: 44px;
    .header {
      padding: 10px;
    }
    .footer {
      padding: 32px 20px;
      .modules-container {
        flex-wrap: wrap;
        .module {
          .title {
            padding-bottom: 10px;
          }
          &.clientService,
          &.protocols {
            width: 50%;
          }
          &.contactUs,
          &.qrcode {
            width: 100%;
            margin-top: 30px;
          }
        }
      }
    }
  }
}
</style>
